// Default values for all calculators
export const websiteDefaults = {
  // Organization Type
  organizationType: 'nonprofit', // 'nonprofit' | 'association'
  
  // Association Specific
  memberCount: 200,
  membershipFee: 150,
  memberGrowthGoal: 10,
  acceptsDonations: 'no', // 'yes' | 'no'

  // Organization Details
  annualOperatingBudget: 500000,
  marketingBudget: 10000,
  websiteBudget: 2500,
  
  // Investment
  websiteInvestment: 17000,
  
  // Donations & Grants
  currentDonations: 50000,
  donationGrowthGoal: 15,
  currentGrants: 60000,
  grantGrowthGoal: 15,
  
  // Staff & Events
  staffHourlyRate: 40,
  currentWebsiteHours: 15,
  eventAttendees: 40,
  volunteerHours: 100,
  organizationAge: 6
};

export const brandingDefaults = {
  // Organization Type
  organizationType: 'nonprofit',
  
  // Association Specific
  memberCount: 200,
  membershipFee: 150,
  memberGrowthGoal: 10,
  acceptsDonations: 'no',

  // Organization Details
  annualOperatingBudget: 500000,
  currentBrandingBudget: 0,
  organizationAge: 6,
  
  // Audience & Reach
  socialMediaFollowers: 205,
  emailListSize: 500,
  monthlyWebsiteVisitors: 4000,
  
  // Current Brand Status
  brandConsistencyRating: 5,
  visualAppealRating: 5,
  brandRecognitionRating: 5,
  
  // Goals & Investment
  donorRetentionGoal: 10,
  audienceGrowthGoal: 15,
  engagementRateGoal: 15,
  brandingInvestment: 7500,
  
  // Shared fields
  staffHourlyRate: 40,
  eventAttendees: 40,
  volunteerHours: 100
};

export const sharedFields = [
  'organizationType',
  'memberCount',
  'membershipFee',
  'memberGrowthGoal',
  'acceptsDonations',
  'annualOperatingBudget',
  'organizationAge',
  'staffHourlyRate',
  'eventAttendees',
  'volunteerHours'
];